import React, { useState } from 'react';
import { SearchIcon, PencilIcon, StarIcon, MapPinIcon, FilterIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
interface Designer {
  id: number;
  name: string;
  location: string;
  specialties: string[];
  rating: number;
  reviewCount: number;
  imageUrl: string;
  portfolioUrl: string;
  availability: string;
  priceRange: string;
  completedCovers: number;
}
const designers: Designer[] = [{
  id: 1,
  name: 'Alex Thompson',
  location: 'Seattle, WA',
  specialties: ['Romance', 'Fantasy', 'Young Adult'],
  rating: 4.9,
  reviewCount: 156,
  imageUrl: 'https://images.unsplash.com/photo-1619539465730-fea9f161d269',
  portfolioUrl: '/portfolio/alex-thompson',
  availability: 'Available Now',
  priceRange: '$300-800',
  completedCovers: 245
}, {
  id: 2,
  name: 'Maria Garcia',
  location: 'Barcelona, Spain',
  specialties: ['Literary Fiction', 'Mystery', 'Horror'],
  rating: 4.8,
  reviewCount: 124,
  imageUrl: 'https://images.unsplash.com/photo-1621784563330-caee0b138a00',
  portfolioUrl: '/portfolio/maria-garcia',
  availability: 'Available from August',
  priceRange: '$400-1000',
  completedCovers: 189
}, {
  id: 3,
  name: 'David Kim',
  location: 'Toronto, CA',
  specialties: ['Sci-Fi', 'Thriller', 'Non-Fiction'],
  rating: 4.7,
  reviewCount: 98,
  imageUrl: 'https://images.unsplash.com/photo-1620964780032-81ef3bf5cedc',
  portfolioUrl: '/portfolio/david-kim',
  availability: 'Limited Availability',
  priceRange: '$500-1200',
  completedCovers: 167
}
// Add more designers as needed
];
const Designers = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedSpecialty, setSelectedSpecialty] = useState('All');
  const specialties = ['All', 'Romance', 'Fantasy', 'Young Adult', 'Literary Fiction', 'Mystery', 'Horror', 'Sci-Fi', 'Thriller', 'Non-Fiction'];
  const filteredDesigners = designers.filter(designer => {
    const matchesSearch = designer.name.toLowerCase().includes(searchTerm.toLowerCase()) || designer.location.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesSpecialty = selectedSpecialty === 'All' || designer.specialties.includes(selectedSpecialty);
    return matchesSearch && matchesSpecialty;
  });
  return <div className="min-h-screen bg-gray-50 py-8" data-id="element-14563" data-mp="15ryfb510ud4t">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-14564" data-mp="15q57vnil3ovr">
        {/* Header */}
        <div className="text-center mb-12" data-id="element-14565" data-mp="1aj83e16x98el">
          <PencilIcon className="h-12 w-12 text-purple-600 mx-auto mb-4" data-id="element-14566" data-mp="1ak9bbwsn5es3" />
          <h1 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-14567" data-mp="wsuspr2nbflk">
            Cover Designers
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-14568" data-mp="11o0g6ubp52br">
            Connect with professional book cover designers to bring your story
            to life
          </p>
        </div>
        {/* Search and Filter */}
        <div className="mb-8 flex flex-col sm:flex-row gap-4" data-id="element-14569" data-mp="85viqcdqu93p">
          <div className="relative flex-1" data-id="element-14570" data-mp="86f0nt3e8xhq">
            <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" data-id="element-14571" data-mp="451tnfokeo98" />
            <input type="text" placeholder="Search by name or location..." className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-14572" data-mp="i4l0m55n3tjy" />
          </div>
          <div className="relative" data-id="element-14573" data-mp="10usyo8uhftta">
            <FilterIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" data-id="element-14574" data-mp="10trdvcnnzsyd" />
            <select className="pl-10 pr-8 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent appearance-none bg-white" value={selectedSpecialty} onChange={e => setSelectedSpecialty(e.target.value)} data-id="element-14575" data-mp="vx0wmm04irbd">
              {specialties.map(specialty => <option key={specialty} value={specialty} data-id="element-14576" data-mp="34bfsjrmjf1so">
                  {specialty}
                </option>)}
            </select>
          </div>
        </div>
        {/* Designers Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-14577" data-mp="3e223h8jb7451">
          {filteredDesigners.map(designer => <div key={designer.id} className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-14578" data-mp="2gf1z5hmgrmk1">
              <img src={designer.imageUrl} alt={designer.name} className="w-full h-48 object-cover" data-id="element-14579" data-mp="2leoebwlurcvh" />
              <div className="p-6" data-id="element-14580" data-mp="2vbspl1e5tnxi">
                <div className="flex justify-between items-start mb-4" data-id="element-14581" data-mp="2v8ofxohxdzzg">
                  <div data-id="element-14582" data-mp="5l7d2sjp7c7u">
                    <h3 className="text-lg font-semibold text-gray-900" data-id="element-14583" data-mp="5o1su6rro8ux">
                      {designer.name}
                    </h3>
                    <div className="flex items-center text-sm text-gray-500 mt-1" data-id="element-14584" data-mp="1v345ykltc0dl">
                      <MapPinIcon className="h-4 w-4 mr-1" data-id="element-14585" data-mp="1q3zzw2u6qirh" />
                      {designer.location}
                    </div>
                  </div>
                  <div className="flex items-center" data-id="element-14586" data-mp="1lbgh8rgn4xft">
                    <StarIcon className="h-5 w-5 text-yellow-400" data-id="element-14587" data-mp="1gegfgsqtqgui" />
                    <span className="ml-1 text-sm text-gray-600" data-id="element-14588" data-mp="1gc3xifl2g6hg">
                      {designer.rating}
                    </span>
                  </div>
                </div>
                <div className="mb-4" data-id="element-14589" data-mp="17byq45fvh83a">
                  <div className="flex flex-wrap gap-2" data-id="element-14590" data-mp="12dx7flmczasc">
                    {designer.specialties.map(specialty => <span key={specialty} className="px-2 py-1 bg-purple-100 text-purple-700 text-xs rounded-full" data-id="element-14591" data-mp="xfvs9bs1zvm5">
                        {specialty}
                      </span>)}
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-4 mb-4 text-sm" data-id="element-14592" data-mp="q35z19ve3lky">
                  <div className="bg-gray-50 p-3 rounded-lg" data-id="element-14593" data-mp="uv6055n74kj4">
                    <div className="text-gray-600" data-id="element-14594" data-mp="uwh87hnoceg1">Completed Covers</div>
                    <div className="text-xl font-semibold text-gray-900" data-id="element-14595" data-mp="g7bbc0cb70bb">
                      {designer.completedCovers}
                    </div>
                  </div>
                  <div className="bg-gray-50 p-3 rounded-lg" data-id="element-14596" data-mp="18vgvolzganam">
                    <div className="text-gray-600" data-id="element-14597" data-mp="1dticf09emaix">Price Range</div>
                    <div className="text-xl font-semibold text-gray-900" data-id="element-14598" data-mp="1dsqtaowzu59j">
                      {designer.priceRange}
                    </div>
                  </div>
                </div>
                <div className="mb-4 text-sm" data-id="element-14599" data-mp="13trhixgxltib">
                  <span className="font-medium text-gray-600" data-id="element-14600" data-mp="3jmqgoo9qslq4">
                    Availability:{' '}
                  </span>
                  <span className="text-green-600" data-id="element-14601" data-mp="3oltky6hwenx1">
                    {designer.availability}
                  </span>
                </div>
                <div className="flex gap-2" data-id="element-14602" data-mp="26q1edkiao04d">
                  <button className="flex-1 bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 transition-colors" data-id="element-14603" data-mp="21pdfkcntqezl">
                    Contact
                  </button>
                  <Link to={`/talent/designers/${designer.id}/portfolio`} className="flex-1 border border-purple-600 text-purple-600 px-4 py-2 rounded-lg hover:bg-purple-50 transition-colors text-center" data-id="element-14604" data-mp="2bnb0aq6h5tng">
                    View Portfolio
                  </Link>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
};
export default Designers;